/**
 * Are we on the embed subdomain?
 */
export const isEmbedSubdomain = () => {
  return window.location.host.startsWith('embed.');
};

/**
 * Are we using the /embed path fragment?
 */
export const isEmbedPath = () => {
  return window.location.pathname.startsWith('/embed');
};

/**
 * Are either of the above conditions true
 */
export const isEmbedded = () => {
  return isEmbedPath() || isEmbedSubdomain();
};
